var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoleConsultant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2231",
    "data-name": "Group 2231",
    transform: "translate(-694 -466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(694 466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_421",
    "data-name": "Path 421",
    transform: "translate(-847 -260)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M897.6,280H870.4a3.41,3.41,0,0,0-3.4,3.4V314l6.8-6.8h23.8a3.41,3.41,0,0,0,3.4-3.4V283.4A3.41,3.41,0,0,0,897.6,280Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    "data-target": "fill",
    d: "M 870.4000244140625 282 C 869.6280517578125 282 869 282.6280517578125 869 283.4000244140625 L 869 309.1716003417969 L 872.9716186523438 305.2000122070312 L 897.5999755859375 305.2000122070312 C 898.35888671875 305.2000122070312 899 304.5588989257812 899 303.8000183105469 L 899 283.4000244140625 C 899 282.6280517578125 898.3719482421875 282 897.5999755859375 282 L 870.4000244140625 282 M 870.4000244140625 280 L 897.5999755859375 280 C 899.469970703125 280 901 281.5299987792969 901 283.4000244140625 L 901 303.8000183105469 C 901 305.6700134277344 899.469970703125 307.2000122070312 897.5999755859375 307.2000122070312 L 873.800048828125 307.2000122070312 L 867 314 L 867 283.4000244140625 C 867 281.5299987792969 868.530029296875 280 870.4000244140625 280 Z",
    stroke: "none",
    fill: "#282d3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "home-2",
    "data-name": "home"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    fill: "none",
    stroke: "#282d3d",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-target": "stroke",
    x: 1,
    y: 1,
    width: 72,
    height: 72,
    rx: 13,
    fill: "none"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleConsultant);
export default __webpack_public_path__ + "static/media/roleConsultant.6251a10f.svg";
export { ForwardRef as ReactComponent };